import React from 'react';
import type { TravelerFields, TravelerFormValues } from '../../api/reservationInfo';
import TravelerSection from './ReservationInfoFormTravelerSection';

type Props = {
  travelerFields: TravelerFields;
  traveler: TravelerFormValues;
  travelerErrors: Partial<Record<keyof TravelerFormValues, string>>;
  onTextChange: (field: keyof TravelerFormValues) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSelectChange: (field: keyof TravelerFormValues) => (e: React.ChangeEvent<HTMLSelectElement>) => void;
  disabled: boolean;
  title: string;
  telLabel: string;
};

const ReservationInfoAirSection = ({
  travelerFields,
  traveler,
  travelerErrors,
  onTextChange,
  onSelectChange,
  disabled,
  title,
  telLabel
}: Props) => {
  return (
    <TravelerSection
      travelerFields={travelerFields}
      traveler={traveler}
      travelerErrors={travelerErrors}
      onTextChange={onTextChange}
      onSelectChange={onSelectChange}
      disabled={disabled}
      title={title}
      telLabel={telLabel}
    />
  );
};

export default ReservationInfoAirSection;
